var _style, _path, _path2, _path3, _path4, _path5, _text, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodyWaterPercentage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#192852;}\r\n\t.st1{fill:#192852;}\r\n\t.st2{font-family:'Poppins-SemiBold';}\r\n\t.st3{font-size:5.8839px;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,9.6c0,0,2.6,0.1,3.1-2.9c-0.1-2,0.6-4.2-2.5-5.4c-0.6-0.1-4-0.3-3.6,4.7C12,7,11.7,9.1,14.7,9.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,16.2v19.4c0,0-0.2,2,1.7,2.4c0.5-0.1,2.4,0.3,2.5-2.2c-0.1-2.5,0-9.2,0-9.2s0.1-1.9,1.6-1.6 c0.5,0.1,1.2,0.3,1.2,1.8c0.1,1.5,0,8.9,0,8.9s0,1.9,1.6,2.2c0.8,0.1,2.2,0.1,2.6-1.9c0-2.2,0-19.4,0-19.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,23.5c0,0,1.3,1.7,2.7,0.6c0.5-0.3,0.9-0.4,0.9-4.4s0-4.9,0-4.9s0.8-4.9-4.9-5.2c-4.5,0-9.1,0-9.1,0 S5.4,9.5,5.6,15c0,4.6,0,7.5,0,7.5S5.5,24,7,24.4c0.9-0.1,1.7,0,2.2-1.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,17c0,0,0.2-2,1.9-1.4c0.2,0.2,1.2,0.8,0.3,1.9c-0.1,0.1-0.5,0.9-1.5,0.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,22.3c0,0-2.2-0.2-1.9-1.8c0.1-0.5,0.4-1.6,1.9-1.4c0.4,0.4,1.1,0.2,1.2,2.2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 24.1406 31.1582)",
    className: "st1 st2 st3"
  }, "90%")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,12.3c0,0,1.5,0.9,2.1,1.1c0.6,0.3,1.4,0.8,3.4,0c1.9-0.8,2.9-1.3,5.9-0.4c0.7,0.4,2,1.4,4.2,0.3 c0.8-0.4,2.2-1.1,2.2-1.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyWaterPercentage);
export default __webpack_public_path__ + "static/media/BodyWaterPercentage.b5c0bdd6570ff66ba2c561e4978c300f.svg";
export { ForwardRef as ReactComponent };